"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsBetaTester = exports.betaTesterSelector = exports.useCreatorData = exports.creatorDataSelector = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const currentRouteParamsRecordId_1 = __importDefault(require("root/src/client/logic/route/selectors/currentRouteParamsRecordId"));
const creatorDataSelector = (state) => {
    var _a, _b, _c;
    const recordId = (0, currentRouteParamsRecordId_1.default)(state);
    return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.api) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.creatorData) === null || _c === void 0 ? void 0 : _c[recordId];
};
exports.creatorDataSelector = creatorDataSelector;
const useCreatorData = () => {
    return (0, useStore_1.useAppSelector)(exports.creatorDataSelector);
};
exports.useCreatorData = useCreatorData;
const betaTesterSelector = (state) => {
    var _a, _b, _c, _d;
    const recordId = (0, currentRouteParamsRecordId_1.default)(state);
    return (_d = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.api) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.creatorData) === null || _c === void 0 ? void 0 : _c[recordId]) === null || _d === void 0 ? void 0 : _d.isBetaTester;
};
exports.betaTesterSelector = betaTesterSelector;
const useIsBetaTester = () => {
    return (0, useStore_1.useAppSelector)(exports.betaTesterSelector);
};
exports.useIsBetaTester = useIsBetaTester;
